import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import submissionRepository from '../Repositories/SubmissionRepository'


class SubmitBloc {

    submitChannel = new Subject();   
    repository = new submissionRepository()

    constructor() {
        this.submitChannel.next({status: apiResponse.INITIAL})
    }

   

    fetchSubmit = async (query) => {
        this.submitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmit(query).then((result) => {
            this.submitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.submitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

   
    
}

export default SubmitBloc